export const ReduxEventEnum = Object.freeze({
    changeLocationCanBack: "changeLocationCanBack",
    setPlaceType: "setPlaceType"
})